import VueDirectiveImagePreviewer from '../src/index'

export default VueDirectiveImagePreviewer



//////////////////
// WEBPACK FOOTER
// ./example/publish.js
// module id = 41
// module chunks = 0